var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/info-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.002 22.7492C6.07195 22.7492 1.25195 17.9292 1.25195 11.9992C1.25195 6.06921 6.07195 1.24921 12.002 1.24921C17.932 1.24921 22.752 6.06921 22.752 11.9992C22.752 17.9292 17.932 22.7492 12.002 22.7492ZM12.002 2.74921C6.90195 2.74921 2.75195 6.89921 2.75195 11.9992C2.75195 17.0992 6.90195 21.2492 12.002 21.2492C17.102 21.2492 21.252 17.0992 21.252 11.9992C21.252 6.89921 17.102 2.74921 12.002 2.74921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 13.7492C11.59 13.7492 11.25 13.4092 11.25 12.9992V7.99921C11.25 7.58921 11.59 7.24921 12 7.24921C12.41 7.24921 12.75 7.58921 12.75 7.99921V12.9992C12.75 13.4092 12.41 13.7492 12 13.7492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.002 16.9997C11.872 16.9997 11.742 16.9697 11.622 16.9197C11.502 16.8697 11.392 16.7997 11.292 16.7097C11.202 16.6097 11.132 16.5097 11.082 16.3797C11.032 16.2597 11.002 16.1297 11.002 15.9997C11.002 15.8697 11.032 15.7397 11.082 15.6197C11.132 15.4997 11.202 15.3897 11.292 15.2897C11.392 15.1997 11.502 15.1297 11.622 15.0797C11.862 14.9797 12.142 14.9797 12.382 15.0797C12.502 15.1297 12.612 15.1997 12.712 15.2897C12.802 15.3897 12.872 15.4997 12.922 15.6197C12.972 15.7397 13.002 15.8697 13.002 15.9997C13.002 16.1297 12.972 16.2597 12.922 16.3797C12.872 16.5097 12.802 16.6097 12.712 16.7097C12.612 16.7997 12.502 16.8697 12.382 16.9197C12.262 16.9697 12.132 16.9997 12.002 16.9997Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0b55f6d3352ad7e4956564fdd917a070.svg";
export { ForwardRef as ReactComponent };